import app from 'flarum/app';
import Field from './Field';
import Switch from 'flarum/components/Switch';

/* global m */

export default class ShortAnswer extends Field {
    whiteListConfigProperties() {
        return super.whiteListConfigProperties().concat([
            'integer',
            'min',
            'max',
        ]);
    }

    configure() {
        return [
            m('.Form-group', Switch.component({
                state: this.getConfig('integer', false),
                onchange: this.setConfig('integer'),
                disabled: this.disabled,
            }, app.translator.trans('kilowhat-formulaire.forum.template-editor.integer'))),
            this.minMaxRules(),
        ];
    }

    fill() {
        const attrs = {
            type: 'number',
            step: this.getConfig('integer') ? 1 : 'any',
            id: this.uniqueFieldId(),
            className: this.validationErrorsForThisField() ? 'in-error' : '',
            value: this.getSubmission(),
            onchange: m.withAttr('value', this.setSubmission.bind(this)),
            disabled: this.isFillDisabled(),
        };

        if (this.getConfig('min')) {
            attrs.min = this.getConfig('min');
        }

        if (this.getConfig('max')) {
            attrs.max = this.getConfig('max');
        }

        return m('input.FormControl', attrs);
    }
}
